const config = {
    "wip": {
        aws_appsync_authenticationType: 'API_KEY',
        aws_appsync_region: 'us-east-1',
        aws_appsync_graphqlEndpoint: 'https://wni77m44w5bnnakgjtwbzcf5lu.appsync-api.us-east-1.amazonaws.com/graphql',
        aws_appsync_apiKey: 'da2-77o5nf2glbeb3ek6ngqhoc5bzm',
        aws_appsync_fanclub_graphqlEndpoint: "https://amsfanclubapi.allmysonsstagingbeanstalk.com/graphql",
    },
    "alpha": {
        Auth: {
            mandatorySignIn: true,
            region: 'us-east-1',
            userPoolId: 'us-east-1_qZh2lcP9V',
            userPoolWebClientId: '671r0k3cqkt3v19641arf8k2gb',
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {}
        },
        aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        aws_appsync_region: 'us-east-1',
        aws_appsync_graphqlEndpoint: 'https://ro5cdffmm5aw3m36vubexnhfqi.appsync-api.us-east-1.amazonaws.com/graphql'
    },
    "beta": {
        Auth: {
            mandatorySignIn: true,
            region: 'us-east-1',
            userPoolId: 'us-east-1_qZh2lcP9V',
            userPoolWebClientId: '671r0k3cqkt3v19641arf8k2gb',
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {}
        },
        aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        aws_appsync_region: 'us-east-1',
        aws_appsync_graphqlEndpoint: 'https://72zgjeur75fd7cqobvxf5qcb34.appsync-api.us-east-1.amazonaws.com/graphql'
    },
    "staging": {
        aws_appsync_authenticationType: 'API_KEY',
        aws_appsync_region: 'us-east-1',
        aws_appsync_graphqlEndpoint: 'https://ndts2mpcvzcq5hlmtdfl4zoww4.appsync-api.us-east-1.amazonaws.com/graphql',
        aws_appsync_apiKey: 'da2-et2dnwmg4nhe3nok3qxi2iwjuu',
        aws_appsync_fanclub_graphqlEndpoint: "https://amsfanclubapi.allmysonsstagingbeanstalk.com/graphql",
    },
    "uat": {
        aws_appsync_authenticationType: 'API_KEY',
        aws_appsync_region: 'us-east-1',
        aws_appsync_graphqlEndpoint: 'https://2cfcpzvojncehdhghbtf3obbn4.appsync-api.us-east-1.amazonaws.com/graphql',
        aws_appsync_apiKey: 'da2-2znkxlm2pvg5lp42btucsmnc2q',
        aws_appsync_fanclub_graphqlEndpoint: "https://amsfanclubapi.allmysonsbeanstalk.com/graphql",
    },
    "prod": {
        aws_appsync_authenticationType: 'API_KEY',
        aws_appsync_region: 'us-east-1',
        aws_appsync_graphqlEndpoint: 'https://lccfazzftfende5il6m3lpef3u.appsync-api.us-east-1.amazonaws.com/graphql',
        aws_appsync_apiKey: 'da2-65e4y5sa2zgqzd7cb6jgdetq5i',
        aws_appsync_fanclub_graphqlEndpoint: "https://amsfanclubapi.allmysonsbeanstalk.com/graphql"
    }
}

export default config[process.env.REACT_APP_ENV];